import React from 'react';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import CardContent from '@mui/material/CardContent';

// Skeleton component for loading state
export default function DealsCardSkeleton() {
	return (
		<Card variant="outlined" data-testid="skeletonLoadingCard">
			<Skeleton variant="rectangular" width="100%" height={300} />
			<CardContent>
				<Skeleton width={100} variant="text" />
				<Skeleton variant="text" />
			</CardContent>
		</Card>
	);
}
